import { useContext } from 'react';
import PeerConnectionContext from '../PeerConnection';

export default () => {
  const PeerConnection = useContext(PeerConnectionContext);

  return PeerConnection;
};
